import {
  put,
  all,
  take,
  takeEvery,
  fork,
  select,
  call
} from "redux-saga/effects";
import * as R from "ramda";
import { actions } from "./model";

import { SEARCH_BAR_INSTANCE_ID_SESSION_SECTION } from "./constants";

import {
  actions as SearchBarActions,
  getters as SearchBarGetters
} from "ui-kit/SearchBar";

import { getSessions } from "Portal/NewPortal/PortalHome/selectors";

const init = function*({ payload: { sessions } }) {
  if (!R.isEmpty(sessions) && R.length(sessions) > 0) {
    yield put(actions.setSessions(sessions));
  }
};

const search = function*() {
  const originalSessions = yield select(getSessions);

  const searchTxt = yield select(SearchBarGetters.searchTerm, {
    instanceId: SEARCH_BAR_INSTANCE_ID_SESSION_SECTION
  });

  const filteredSessions = R.filter(({ name }) =>
    name.toLowerCase().includes(searchTxt ? searchTxt.toLowerCase() : "")
  )(originalSessions);
  yield put(actions.setSessions(filteredSessions));
};

const clearSearchSessions = function*() {
  const originalSessions = yield select(getSessions);
  yield put(actions.setSessions(originalSessions));
};

const watchSearch = function*() {
  yield takeEvery(
    action =>
      action.type === SearchBarActions.setSearchTerm.type &&
      R.path(["meta", "instanceId"], action) ===
        SEARCH_BAR_INSTANCE_ID_SESSION_SECTION,
    search
  );
};

const watchClearSearch = function*() {
  for (;;) {
    const action = yield take(SearchBarActions.clearSearch.type);
    if (
      R.path(["meta", "instanceId"], action) ===
      SEARCH_BAR_INSTANCE_ID_SESSION_SECTION
    ) {
      yield call(clearSearchSessions, action);
    }
  }
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const rootSaga = function*() {
  yield all([fork(watchInit), fork(watchSearch), fork(watchClearSearch)]);
};

export default rootSaga;
